import * as ko from "knockout";
import {_d} from "../../util/misc";
import {nsRoute} from "../../util/route";
import {IMessageData, IRouteDefinitionParams, ISystem, ISystemRole} from "../../index";
import {nsLogin} from "../../util/nsLogin";
import {ERROR_MESSAGE, PLEASE_WAIT_MESSAGE} from "../../constants/Language";
import PromiseRequest from "../../req/PromiseRequest";
import {getSearchSystemParams} from "../../util/request";
import {MAX_RESULTS_PER_PAGE} from "../../constants";
import {getHash} from "../../constants/RouteDefinitions";
import {hasher} from 'hasher';
import decodeRedirectUrl = nsLogin.decodeRedirectUrl;
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import redirectHtml from './redirect.html?raw';

export const template = redirectHtml;

export class viewModel extends ParsedRouteDataDecorator {
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private readonly routeOptions: any;
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null)
    private promiseRequest!: PromiseRequest

    constructor(params: IRouteDefinitionParams) {
        super(params);
        if (this.__routeParams?.options) {
            try {
                this.routeOptions = JSON.parse(decodeRedirectUrl(this.__routeParams.options))
                this.init()
            } catch {
                this.messageData({message: ERROR_MESSAGE})
                _d.warn('Failed to parse route options')
            }
        }
    }

    private init() {
        this.messageData({message: PLEASE_WAIT_MESSAGE})

        // --- SYSTEMROLEID ------------------------------------------------------------------------------------------->
        if (this.routeOptions.systemroleid) {
            this.promiseRequest = new PromiseRequest('searchsystem')
            this.promiseRequest
                .request(getSearchSystemParams({
                    resultsprpage: MAX_RESULTS_PER_PAGE,
                }))
                .then((data: ISystem[]) => {
                    let systemrole: ISystemRole | undefined;
                    for (const system of data) {
                        systemrole = system.roles.find(role => role.id == this.routeOptions.systemroleid);
                        if (systemrole) {
                            break;
                        }
                    }
                    if (systemrole) {
                        hasher.setHash(getHash('systemaccessdetails', {id: systemrole.systemid}))
                    }
                })
        }
    }

    override dispose() {
        this.promiseRequest?.abort?.()
    }

}